<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form @submit="EditHistorique" :validation-schema="HistoriqueSchema" ref="historiqueForm">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Numéro d'Ordre<span class="text-danger">*</span>
              </label>
              <Field name="numOrdre" type="text"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrez le numéro d'Ordre"/>
              <ErrorMessage name="numOrdre" class="text-danger"/>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Image  <span class="text-danger">*</span>
              </label>
              <Field name="urlImage" type="file" 
                class="form-control shadow-none fs-md-15 text-black"/>
              <ErrorMessage name="urlImage" class="text-danger"/>
              <small class="text-muted">Laissez vide pour conserver l'image actuelle</small>
            </div>
          </div>
          
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Desciption<span class="text-danger">*</span>
              </label>
              <Field name="description" as="textarea"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrez la description"/>
              <ErrorMessage name="description" class="text-danger"/>
            </div>
          </div>
          <div class="col-md-12">
            <div class="d-flex align-items-center ">
              <button
                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 
                pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit"
              >
                  Modifier
              </button>
              <router-link to="/historique" 
                  class=" btn btn-danger transition border-0 lh-1 fw-medium"><i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                  <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import { error, success, getUrlApiForFiles, getUrlApiForFilesHistorique } from "../../utils/utils";
import { useRoute, useRouter } from "vue-router";
import ApiService from "../../services/ApiService";
import * as Yup from "yup";
import axios from "axios";
import Swal from "sweetalert2";

export default defineComponent({
  name: "EditHistorique",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  
  setup: () => {
    const router = useRouter();
    const route = useRoute();
    const historiqueForm = ref();
    const historique = ref<any>(null);
    const currenturlImage = ref("");
    
    const HistoriqueSchema = Yup.object().shape({
      description: Yup.string().required("La description est obligatoire"),
      numOrdre: Yup.string().required("Le numéro d'ordre est obligatoire"),
      urlImage: Yup.mixed().notRequired(), 
    });

    onMounted(() => {
      const id = route.params.id as string;
      if (id) {
        getHistorique(parseInt(id));
      }
    });

    const getHistorique = async (id: number) => {
      try {
        const response = await ApiService.get(`/historique/${id}`);
        historique.value = response.data.data;
        currenturlImage.value = historique.value.urlImage;
        
        // Pré-remplir le formulaire
        if (historiqueForm.value) {
          historiqueForm.value.setValues({
            description: historique.value.description,
           numOrdre: historique.value.numOrdre
          });
        }
      } catch (err: any) {
        console.error("Erreur lors du chargement:", err);
        error("Erreur lors du chargement de l'historique");
      }
    };

    const EditHistorique = async (values: any, { resetForm }: any) => {
      try {
        console.log("Données envoyées:", values);
        
        // Si aucune nouvelle image n'est sélectionnée, on supprime le champ du FormData
        // pour que le backend conserve l'ancienne image
        const formData = new FormData();
        
        // Ajouter tous les champs texte
        formData.append('description', values.description);
        formData.append('numOrdre', values.numOrdre);
        // Ajouter les images seulement si elles sont sélectionnées
        if (values.urlImage && values.urlImage instanceof File) {
          formData.append('urlImage', values.urlImage);
        }
        
        const id = route.params.id as string;
        const response = await axios.put(`/historique/${id}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': '*/*'
          }
        });

        if (response.data.code === 200) {
          success(response.data.message || "Historique modifié avec succès");
          router.push({ name: "ListeHistoriquePage" });
        }
      } catch (err: any) {
        console.error("Erreur lors de la modification:", err);
        if (err.response?.data?.message) {
          error(err.response.data.message);
        } else {
          error("Une erreur est survenue lors de la modification de l'historique");
        }
      }
    };

    return { 
      HistoriqueSchema,
      EditHistorique,
      historiqueForm,
      historique,
      currenturlImage,
      getUrlApiForFilesHistorique
    };
  },
});
</script>